module.exports = __webpack_public_path__ + "a8b82e84.png";